import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Center, Spinner, Text, VStack } from '@chakra-ui/react';

import api from 'state/api';

const AUTH_TIMEOUT_MS = 8000;

const getStoredToken = () =>
  localStorage.getItem('token') ?? sessionStorage.getItem('token');

const ProtectedRoute = ({ element }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    const finish = (authed) => {
      if (cancelled) return;
      setIsAuthenticated(authed);
      setIsLoading(false);
    };

    const validateUser = async () => {
      const token = getStoredToken();
      if (!token) {
        finish(false);
        return;
      }

      try {
        const response = await api.get('auth', {
          timeout: AUTH_TIMEOUT_MS,
          headers: { Authorization: `Bearer ${token}` },
        });
        finish(response.status === 200 && response.data?.success !== false);
      } catch (error) {
        console.error('Failed to validate token:', error);
        finish(false);
      }
    };

    validateUser();

    return () => {
      cancelled = true;
    };
  }, []);

  if (isLoading) {
    return (
      <Center minH="100vh">
        <VStack spacing={3}>
          <Spinner size="lg" color="blue.500" />
          <Text fontSize="sm" color="gray.500">
            Loading...
          </Text>
        </VStack>
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/sign-in" state={{ from: location }} replace />;
  }

  return <>{element}</>;
};

export default ProtectedRoute;
